import Avatar from "@components/profile/avatar"
import VideoPlayer from "../Videos/VideoPlayer";
import { ICameraVideoTrack, ILocalVideoTrack, IRemoteVideoTrack } from "agora-rtc-sdk-ng";

interface ICurrentUserVideoProps
{
    showVideo: boolean,
    videoTrack: ILocalVideoTrack | IRemoteVideoTrack | ICameraVideoTrack,
    username: string,
    size: number
}

/**
 * @abstract Component that handles current user in videocall to render it's video tracks or shows the avatar
 */
const CurrentUserVideo = (props: ICurrentUserVideoProps) => {
    const { showVideo, videoTrack, username, size } = props;
    return (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <>
            {
                showVideo && videoTrack ?
                <VideoPlayer
                    className=""
                    videoTrack={videoTrack}
                    style={{ borderRadius: '0px', width: '100%', height: '100%' }}
                />
                :
                <div className="VideoCall__Avatar">
                    <Avatar
                        username={username}
                        roleCode="PR"
                        size={30}
                        editable={false}
                    />
                </div>
            }
        </>
    )
}

export default CurrentUserVideo;
